import Immutable from 'immutable';
import _ from 'lodash';

// AWS doesn't apparently know how to work with modern js, need to import the compiled version which exposes to window
// import entire SDK - https://github.com/aws/aws-sdk-js/issues/603
// import 'aws-sdk/dist/aws-sdk';
// const AWS = window.AWS;
//
// import 'aws-sdk-mobile-analytics/dist/aws-sdk-mobile-analytics';
// const AMA = window.AMA;


/**
 * TODO
 * Note: for the sake of time, i'm lazy loading this with a manual stub during unit 'tests'.
 * Need to figure out a better overall global mocking strategy since I'm having issues with jsdom-global
 * http://airbnb.io/enzyme/docs/guides/jsdom.html
 */
const RavenStub = {
  config: function() {
    return this;
  },
  install: function () {
    return this;
  },
  setTagsContext: function () {
    return this;
  },
  setUserContext: function () {
    return this;
  },
  captureMessage: function () {
    return this;
  },
  captureBreadcrumb: function () {
    return this;
  },
  captureException: function () {
    console.error('raven exception');
    return this;
  }
};
const Raven = (process.env.NODE_ENV === 'test')
  ? RavenStub
  : require('raven-js');

Raven.config(
  'https://cc83cef2df76474d90126ac4eed20989@sentry.io/124423',
  {
    autoBreadcrumbs: {
      console: false,
    },
  },
)
  .install()
  // .setTagsContext({
  //   environment: process.env.NODE_ENV || 'development',
  // });

function getDrupalUser() {
  return (window.Drupal && window.Drupal.settings)
    ? (window.Drupal.settings.currentUser || '')
    : '';
}

function applyDeep(o, func) {
  for (const i in o) {
    func.apply(this, [o, i]);
    if (o[i] !== null && typeof (o[i]) === 'object') {
      // going on step down in the object tree!!
      applyDeep(o[i], func);
    }
  }
}

function removeNulls(obj, key) {
  if (obj[key] === undefined || obj[key] === null) {
    delete obj[key];
  }
  return obj;
}

/**
 * @param attributes
 * @returns {*}
 * Removes null values and truncates values 200 chars for recordEvent (side effecty)
 */
const truncateAWSAttributes = (attributes) => {
  applyDeep(attributes, removeNulls);

  return _.mapValues(attributes, (v) => {
    const asString = (typeof v === 'string')
      ? v
      : JSON.stringify(v);

    return asString.substr(0, 200);
  });
};


// add more actions you want to log here as needed
const actionMessagesMapper = {
  SERVICE_ERROR: (action, state) => {
    // Raven.setUserContext({
    //   currentUser: getDrupalUser(),
    // });
    //
    // Raven.captureMessage(action.type, {
    //   extra: {
    //     action,
    //     state,
    //   },
    //   level: 'error',
    // });
  },
};

/**
 * @param action
 * @param state
 * Buffers the actions via breadcrumbs which are released when Raven.captureMessage is called on service error
 */
export const logActionToRaven = (action, state) => {
  // Buffer the actions (breadcrumbs) to be released by raven whenever Raven.captureMessage is called
  // Raven.captureBreadcrumb({
  //   message: action.type,
  //   category: 'action',
  //   data: {
  //     action,
  //     state,
  //   },
  // });

  const errorMessage = actionMessagesMapper[action.type];
  if (errorMessage) {
    errorMessage(action, state);
  }
};

export const logException = (error, info) => {
  // Raven.captureException(error, info);
};

// Note: recordEvent takes the attributes, metrics and stringifies whatever you input.
// this is an actual mutation, be careful it modifies the actual source variable as well
export const logActionToAWSAnalytics = (action, state) => {
  // record event takes optional args attributes, metrics
  const name = action.type || 'action';
  const currentUser = { currentUser: getDrupalUser() };
  const attributes = Object.assign({}, currentUser, action);
  const truncatedAttributes = truncateAWSAttributes(attributes);

  window.mobileAnalyticsClient.recordEvent(name, truncatedAttributes);
};


export const initAWSMobileAnalytics = () => {
  window.AWS.config.region = 'us-east-1';
  window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'us-east-1:7da6a325-e959-4876-a13d-b516964d3e1f', // Amazon Cognito Identity Pool ID
  });

  // There's nowhere to place an environment config?
  // Suggestion is to use a seperate config but for now I'm just skipping dev logging
  // http://stackoverflow.com/questions/29803540/aws-mobile-analytics-enviornment
  const options = {
    appId: '1c31009f8a174788a57274fac211b38f', // Amazon Mobile Analytics App ID
    appTitle: 'Justin Example App', // Optional e.g. 'Example App'
    // ,logger   : console                        //Optional helps with debugging
    // appVersionName : APP_VERSION_NAME, //Optional e.g. '1.4.1'
    // appVersionCode : APP_VERSION_CODE, //Optional e.g. '42'
    // appPackageName : APP_PACKAGE_NAME  //Optional e.g. 'com.amazon.example'
  };

  window.mobileAnalyticsClient = new window.AMA.Manager(options);
};



/** WEBPACK FOOTER **
 ** ./src/util/logger.js
 **/